import dialogPolyfill from 'dialog-polyfill'
import { useCallback, useEffect, useRef } from 'react'
import { useStore } from '../../store'
import { Handler } from 'mitt'
import { ToastBody, ToastWrapper } from './StyledToast'
import { CSSTransition } from 'react-transition-group'
import appExpose from '@app/expose'

const emitter = appExpose.emitter

export default function Toast() {
  const toastRef = useRef<HTMLElement | null>(null)
  const timeout = useRef<number | undefined>(undefined)
  const { state, dispatch } = useStore()
  const open = state.toastData.open
  const toastTimeout = state.toastData.timeout
  const content = state.toastData.content
  const isDialog = state.toastData.dialog
  const landscape = window.screenDetectResult.landscape
  const type = isDialog ? 'dialog' : 'div'
  const getElem = (elem: unknown) => {
    toastRef.current = elem as HTMLElement
  }

  useEffect(() => {
    const _handle: Handler<ToastEvent> = (e) => {
      dispatch({
        type: 'setToastData',
        data: {
          open: true,
          dialog: e.dialog,
          content: e.text,
          timeout: e.timeout,
        },
      })
    }

    emitter.on('toast', _handle)

    return () => {
      emitter.off('toast', _handle)
    }
  }, [])

  useEffect(() => {
    let toastElem: HTMLDialogElement | null = null
    if (open) {
      if (isDialog) {
        toastElem = toastRef.current as HTMLDialogElement
        if (toastElem) {
          dialogPolyfill.registerDialog(toastElem)
          toastElem.onkeydown = (e) => {
            if (e.key === 'Escape') {
              e.preventDefault()
            }
          }
          toastElem.showModal()
        }
      }
      clearTimeout(timeout.current)
      timeout.current = window.setTimeout(() => {
        dispatch({
          type: 'setToastData',
          data: {
            open: false,
            dialog: false,
          },
        })
      }, toastTimeout)
    }
    return () => {
      clearTimeout(timeout.current)
      if (isDialog && toastElem) {
        toastElem.open = false
      }
    }
  }, [open, isDialog])

  return (
    <CSSTransition
      nodeRef={toastRef}
      in={open}
      timeout={300}
      unmountOnExit
      classNames="turn"
    >
      <ToastWrapper as={type} type={type} ref={getElem}>
        <ToastBody $landscape={landscape}>{content}</ToastBody>
      </ToastWrapper>
    </CSSTransition>
  )
}
